module.exports = __webpack_public_path__ + "static/media/student-icon.7203366b.svg";